export default __webpack_public_path__ + "static/media/evenslapenKlein.1aa8cbeb.jpg";